import Vue from 'vue'

const mutations = {
  teams: (state, teams) => {
    return Vue.set(
      state,
      'teams',
      teams
    )
  },
  currentTeam: (state, team) => {
    return Vue.set(
      state,
      'currentTeam',
      team
    )
  }
}

export default mutations
